import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const datastrategyicon = "/assets/icons/data_strategy icon.png";
const dataengineeringicon = "/assets/icons/data_engineering icon.png";
const datavisualizationicon = "/assets/icons/data_dashboard icon.png";
const aimlicon = "/assets/icons/ai_ml_icon.png";
const biicon = "/assets/icons/bi_solution icon.png";
const bigdata = "/assets/icons/big_ata icon.png";


const DataAnalysis = () => {

  useEffect(() => {
    document.title = 'Data Analytics | Inypeople';
  }, []);
  return (
    <>
      
      <section className="web-dev-section data-analytics-page">
        <div className="web-dev-container">
          <h1 className="web-dev-title">Data & Analytics</h1>
            <p className="data-analytics-description">
            At Inypeople, we deliver cutting-edge Data & Analytics solutions tailored to your organization’s unique needs. From custom dashboards and reporting to industry-specific analytics, we transform raw data into actionable insights that support smarter decision-making.
            <br />
            <br />
            Our analytics solutions are designed to drive operational efficiency, uncover new opportunities, and fuel sustainable growth. By combining advanced tools, domain expertise, and scalable architectures, we help businesses innovate faster and stay competitive in a data-driven world.

          </p>

        </div>

        <div className="circle circle-left"></div>
        <div className="circle circle-right"></div>
        <div className="circle circle-right-top"></div>
        <div className="circle circle-left-bottom"></div>
      </section>

      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">Leverage data analytics to build smarter, engaging interfaces.</h2>

          <div className="services-grid">
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={datastrategyicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Data Strategy & Consulting</h3>
                </div>

                <p className="service-description">
                  Define a clear data roadmap aligned with your business goals. We help you unlock the true value of data through governance, architecture, and analytics strategy. Build a strong foundation for data-driven decisions.
                </p>
              </div>
            </div>

            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={dataengineeringicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Data Engineering & Warehousing</h3>
                </div>
                <p className="service-description">
                  Present complex data through clear, intuitive visualizations. Real-time dashboards improve clarity and decision-making. Designed for impact and usability.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={datavisualizationicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Data Visualization & Dashboards</h3>
                </div>
                <p className="service-description">
                  Present complex data through clear, intuitive visualizations. Real-time dashboards improve clarity and decision-making. Designed for impact and usability.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={aimlicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">AI & Machine Learning Solutions</h3>
                </div>
                <p className="service-description">
                  Leverage AI and ML to automate processes and predict outcomes. Build intelligent systems that enhance efficiency and accuracy. Turn data into competitive advantage.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={biicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Business Intelligence (BI) Solutions</h3>
                </div>
                <p className="service-description">
                  Transform data into actionable insights with interactive BI tools. Custom dashboards and reports empower faster, smarter decisions. Tailored to your business needs.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={bigdata}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Big Data Analytics</h3>
                </div>
                <p className="service-description">
                  Analyze large, complex datasets to uncover hidden patterns and trends. Our solutions enable real-time and advanced analytics at scale. Drive innovation with data-backed insights.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Add GetInTouch at the bottom of this service page */}
      <GetInTouch />
    </>
  );
};

export default DataAnalysis;
